import React from 'react';
import styled from '@emotion/styled';
import { useExampleSentenceTranslation } from '@seedlang/hoc';
import { QuestionIcon } from '@seedlang/icons';
import { Theme } from '@seedlang/constants';
import LanguageButton from 'components/button/language_button';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  margin: 8px 0 4px;
  color: ${props => props.color};
`;

const Toggle = styled.button`
  position: absolute;
  top: ${props => props.inset}px;
  right: ${props => props.inset}px;
  z-index: ${Theme.z['card-3']};
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  border-radius: 10px;
  background: #FFF;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;

export const ExampleSentenceToggle = ({ inset = 5, showHint = false, onShowHint, disabled = false }) => {
  const { canToggle, translated, toggleLanguage, languageId } = useExampleSentenceTranslation();
  if (!showHint && !canToggle) return null;
  const label = showHint ? 'Show Hint' : translated ? 'Show original sentence' : 'Show sentence translation';
  return (
    <Toggle inset={inset} disabled={disabled} onClick={showHint ? onShowHint : toggleLanguage} title={label} aria-label={label} aria-pressed={showHint ? undefined : translated}>
      {showHint ? <QuestionIcon hideOutline width="26px" height="26px" fill="#333" /> : <LanguageButton languageId={languageId} />}
    </Toggle>
  );
};

const Sentence = styled.div`
  flex: 1;
  min-width: 0;
  display: grid;
  align-items: start;
  font-family: inherit;
  font-size: ${props => props.fontSize}px;
  font-style: normal;
  line-height: ${props => props.fontSize + 4}px;
  overflow-wrap: anywhere;
  text-align: center;
  span[data-underlined='true'] {
    text-decoration-line: underline;
    text-decoration-style: dotted;
    text-decoration-color: ${Theme.orange};
    text-decoration-thickness: 2px;
    text-underline-offset: 3px;
    text-decoration-skip-ink: none;
  }
`;

const SentenceLayer = styled.div`
  grid-area: 1 / 1;
  min-width: 0;
  padding-bottom: 4px;
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
`;

const ExampleSentence = ({ parts, translation, languageId, revealed, allowTranslation = false, color = '#333', fontSize = 16 }) => {
  const { translated } = useExampleSentenceTranslation({ parts, translation, languageId, revealed, allowTranslation });

  return (
    <Wrapper color={color}>
      <Sentence fontSize={fontSize}>
        <SentenceLayer visible={!translated} aria-hidden={translated}>
          {parts.map((part, index) => (
            <span key={index} data-underlined={part.underline}>{part.text}</span>
          ))}
        </SentenceLayer>
        <SentenceLayer visible={translated} aria-hidden={!translated}>
          {translation?.text}
        </SentenceLayer>
      </Sentence>
    </Wrapper>
  );
};

export default ExampleSentence;
